module.exports = __webpack_public_path__ + "img/receta-header.f48c3c63.png";